import React, { useState, useEffect, useRef } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import { ErrorMessage, Formik, Form as FormFormik, Field } from 'formik';
import { api } from '../../services/contratoApi/index';
import * as yup from 'yup';
import moment from 'moment';
import CardAviso from '../card-aviso/index.jsx';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

const Avisos = () => {
    const [loading, setLoading] = useState(true);
    const [avisos, setAvisos] = useState([]);
    const [modalNovoAviso, setModalNovoAviso] = useState(false);
    const permisao = decriptObjectOnLocalStorage('PERM');
    const autor = decriptoLocalStorage('Nome')?.decriptoValue;
    const dataAtual = moment().format('YYYY-MM-DD');
    const codigoUsuario = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const avisosOrdenados = avisos.sort((a, b) => b.Id_mess - a.Id_mess);
    const mensagemSucesso = useRef(null);
    const mensagemErro = useRef(null);

    const mostrarMensagemSucesso = () => {
        mensagemSucesso.current.show({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Aviso inserido com sucesso!',
            life: 2000,
            closable: false
        });
    };

    const mostrarMensagemErro = () => {
        mensagemErro.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível inserir o aviso!',
            life: 4000,
            closable: false
        });
    };

    const recarregarPagina = () => {
        window.location.reload();
    };

    const schema = yup.object().shape({
        Titulo: yup
            .string()
            .min(3, 'Assunto precisa ter mais de 3 caracteres.')
            .max(100, 'Assunto precisa ter menos de 100 caracteres.')
            .required('Assunto é um campo obrigatório!'),
        Texto: yup
            .string()
            .max(255, 'A descrição precisa ter menos de 255 caracteres')
            .required('Descrição é um campo obrigatório!')
    });

    const valoresIniciais = {
        CodigoUsuario: codigoUsuario,
        Data_Criacao: dataAtual,
        TipoPerm: permisao,
        Texto: '',
        Titulo: ''
    };
    const buscarAvisos = async () => {
        try {
            const retornoDeAvisos = await api.get('avisos/');

            setTimeout(() => {
                if (retornoDeAvisos.status === 200) {
                    setAvisos(retornoDeAvisos.data);
                    setLoading(false);
                }

                setLoading(false);
            }, 2000);
        } catch {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    };

    useEffect(() => {
        buscarAvisos();
    }, []);

    const handleSubmit = async values => {
        try {
            const cadastrarAviso = await api.post('/avisos', values);

            if (cadastrarAviso.status === 200) {
                setModalNovoAviso(false);
                mostrarMensagemSucesso();
            }
        } catch (error) {
            mostrarMensagemErro();
        }
    };

    const header = <img alt="Card" src={FundoAmarelo} />;

    const conteudoModal = () => {
        if (modalNovoAviso) {
            return (
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={valoresIniciais}
                    validationSchema={schema}
                >
                    <FormFormik className="p-grid modal-wrapper">
                        <div className="p-col-6  item-modal">
                            <div className="title">
                                <span>Data</span>
                            </div>
                            <input
                                type="date"
                                name="data"
                                id="data"
                                value={dataAtual}
                                disabled
                                mask="99/99/9999"
                            />
                        </div>
                        <div className="p-col-6 item-modal">
                            <div className="title">
                                <span>Autor</span>
                            </div>
                            <input
                                type="text"
                                name="autor"
                                id="autor"
                                value={autor}
                                disabled
                            />
                        </div>
                        <div className="p-col-12 item-modal">
                            <div className="title">Assunto</div>

                            <Field as="input" name="Titulo" id="Titulo" />
                            <ErrorMessage
                                component="div"
                                name="Titulo"
                                id="Titulo"
                                style={{ color: 'red' }}
                            />
                        </div>
                        <div className="p-col-12 item-modal">
                            <div className="title">
                                <span>Descrição</span>
                            </div>

                            <Field as="textarea" name="Texto" id="Texto" />
                            <ErrorMessage
                                component="div"
                                name="Texto"
                                id="Texto"
                                style={{ color: 'red' }}
                            />
                        </div>
                        <div className="botoes-modal-novo-aviso">
                            <Button
                                label="Cadastrar"
                                icon="pi pi-plus"
                                iconPos="right"
                                type="submit"
                            />
                        </div>
                    </FormFormik>
                </Formik>
            );
        } else {
            return null;
        }
    };

    // * Função que renderiza os cards de avisos de acordo com a permissão do usuário
    const conteudoCard = () => {
        if (permisao === '7') {
            return (
                <div className="card-container">
                    <div className="card-aviso-header">
                        <Button
                            label="Novo Aviso"
                            icon="pi pi-plus"
                            iconPos="right"
                            onClick={() => setModalNovoAviso(true)}
                        />
                    </div>
                    <CardAviso props={avisosOrdenados} />
                    <Dialog
                        onHide={() => setModalNovoAviso(false)}
                        header="Novo Aviso"
                        modal
                        visible={modalNovoAviso}
                        dismissableMask
                    >
                        {conteudoModal()}
                    </Dialog>
                </div>
            );
        } else {
            return (
                <div className="card-container">
                    <CardAviso props={avisosOrdenados} />
                </div>
            );
        }
    };

    return (
        <>
            {loading ? (
                <div className="loading-container">
                    <ProgressSpinner
                        style={{ width: '250px',
                            height: '150px' }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration="0.5s"
                        className={loading}
                    />
                </div>
            ) : (
                <>
                    <Card className='tratar-scroll-card' header={header} title="Meus Avisos">
                        {conteudoCard()}
                        <Growl ref={mensagemSucesso} onRemove={recarregarPagina} />
                        <Growl ref={mensagemErro} />
                    </Card>
                </>
            )}
        </>
    );
};

export default Avisos;
